import { Theme } from "../../../../components/constants";

export default {
    createFormContainer: {
        display: "flex",
        flexDirection: "column",
        flex: 1,
    },
    bodyContainer: {
        display: "flex",
        flexDirection: "column",
        flex: 1,
    },
    headerRow: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        flexWrap: "wrap",
    },
    stepperRow: {
        display: "flex",
        flexDirection: "column",
        flex: 1,
        marginTop: "30px"
    },
    selectedFormInfo: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
    },
    formHeading:{
        marginBottom: "0",
    },
    formToolTip: {
        marginLeft: "10px"
    },
    formSubId: {
        fontWeight: 400,
        color: Theme.DISABLED_TEXT,
        marginLeft: "10px",
    },
    previewOptionDiv: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
    },
    previewFormText: {
        fontWeight: 700,
        lineHeight: "19px",
        color: Theme.PRIMARY,
        marginRight: "30px",
    },
    irsViewSwitch:{
        marginRight: "8px",
        display: "flex",
    },
    irsViewText: {
        lineHeight: "20px",
        color: Theme.DISABLED_TEXT,
    },
    popupChildrenStyle: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        paddingBottom: "40px",
    },
    reportErrorsDownloadPopupInnerDiv: {
        display: "flex",
        flexDirection: "row",
        gap: "20px",
        alignItems: "center",
    },
}